<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">设置性别</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			根据人的ID修改该人的性别属性。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public int SKFaceSetPersonSex(String PersonID, int PersonSex);</code></pre>
		<h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">
             <p class="doc_main_p">（1）PersonID：人员ID</p>
             <p class="doc_main_p">（2）PersonSex：人员性别，1：女，2：男，其他无效</p>
        </p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
            是否设置成功：0：成功，其他：失败
        </p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code"> int setSex = skFaceSDKLive.SKFaceSetPersonSex("203423",1);</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Android','视频接口','设置性别'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	


// WEBPACK FOOTER //
// src/views/documents/skfacesdklive/voideinitiali/VoideSex.vue